import React from 'react'
import BarChart from 'src/blades/barChart'
import SelectInput from '../shared/selectInput';
import numberFormatter from 'src/utils/numberFormatter'
import { numberFormat } from 'highcharts';
import NoData from '../shared/noDataComponent';
const chartProps = {
    type: "column",
    backgroundColor: "Transparent",
    height: 400,
    marginBottom: 100,
    marginTop: 30,
    style: {
        fontFamily: "Segoe UI",
    }
};
const otherOptions = {
    title: {
        text: ''
    },
    tooltip: {
        formatter: function () {
            const { number: value, suffix = '' } = numberFormatter(this.y)
            return `<b>$${numberFormat(value, 2, '.', ',')}${suffix}</b>`;
        }
    },
    credits: {
        enabled: false
    },
    legend: {
        enabled: false
    },
    xAxis: {
        type: 'category',
        labels: {
            enabled: true,
            rotation: -45,
            formatter: function () {
                const text = this.value,
                    formatted = text.length > 15 ? text.substring(0, 12) + '...' : text;

                return '<div title="' + text + '">' + formatted + '</div>';
            },
            useHTML: true
        },
    },
    yAxis: {
        title: {
            text: 'USD'
        },
        labels:{
            formatter: function () {
                const { number: value, suffix = '' } = numberFormatter(this.value)
                return `${numberFormat(value, 2, '.', ',')}${suffix}`;
            }
        }
    },
    lang: {
        thousandsSep: ','
    },
}

const AnalyticsBarGraph = ({seriesData,yearLu,onYearChange,selectedYear }) => {

    const isSeriesDataValid = (typeof seriesData === 'string' || !seriesData);
    const handleYearChange = (year) => {
        onYearChange(year);
    };
    return (
        <div>
            <div className='chart-titleflex flex justify-between items-center'>
                <h3 className='text-light-addonColor text-lg font-sans font-semibold'> {!isSeriesDataValid ? seriesData.heading : 'Analytics Data'}</h3>
                <SelectInput
                    showSearch={false}
                    allowClear={false}
                    options={yearLu}
                    onChange={handleYearChange}
                    defaultValue={selectedYear}
                    customClass='!w-24 pt-0'
                />
            </div>
          { !isSeriesDataValid && <BarChart
                shouldFetch={false}
                chartProperties={chartProps}
                seriesKey="movementChart"
                otherOptions={otherOptions}
                seriesData = {seriesData}
            />}
            {isSeriesDataValid && <div className="chart-nodata"><span><NoData /></span></div>}
        </div>
    );
}

export default React.memo(AnalyticsBarGraph)